<template>
   <view class="warp" wx:style="{{warpStyle}}">
    <block wx:if="{{!error}}">
      <text class="rule" wx:style="{{ruleStyle}}" bindtap="gotoLink(pageConfig.rule.link)">规则</text>
      <image class="header-image" src="{{pageConfig.header.image2}}" mode="widthFix" />
      <red-packet-open
        wx:if="{{hasGetCoupon && hasCoupon && couponList}}"
        template="{{info.template}}"
        btnText="{{btnText}}"
        couponList="{{couponList}}"
        bind:couponClick="couponToUse"
        bind:click="toUseCoupon"
      />
      <red-packet-close
        wx:elif="{{activityCouponInfo || pageConfig}}"
        couponInfo="{{activityCouponInfo}}"
        config="{{pageConfig.redPacket}}"
        template="{{info.template}}"
        btnText="{{btnText}}"
        bind:click="getCoupon"
      />
      <gas-station-list
        wx:if="{{stationParams}}"
        class="container-station"
        params={{stationParams}}
        bind:footerBtnClick="toMoreStation"
      />
      <image-list imageList="{{pageConfig.imageList}}" />
      <res-banner wx:if="{{activityCouponInfo}}" template="{{info.template}}" />
    </block>
    <error-view wx:else message="{{errmsg}}" />
    <popup-result
      wx:if="{{popupResult}}"
      popupData="{{popupResult}}"
      pageConfig="{{pageConfig}}"
      bind:close="popupClose"
      bind:click="popupClick"
    />
  </view>
</template>

<script>
import { createComponent } from '@mpxjs/core'
import { props as properties } from './model/props'
import { trackEvent } from '@didi/webx-js'
import { preloadImage } from '../../lib/utils'
import couponMixin from '../../lib/mixin/coupon-v3'
import store from '../../lib/store'

preloadImage([ 'https://ut-static.udache.com/webx/ut/Qk3iLujX5dHRxAwXP8oGr.png', 'https://ut-static.udache.com/webx/ut/1BlI3rZCQaodbU4jjvhNI.png', 'https://ut-static.udache.com/webx/ut/sAYW0BpU0qkjXlnUxp_9p.png' ], 1000)

createComponent({
  properties,
  mixins: [ couponMixin ],
  data: {
  },
  computed: {
    ...store.mapGetters([ 'cityInfo' ]),
    stationParams() {
      if (
        this.pageConfig.index.showStation &&
        this.userInfo.token &&
        this.cityInfo.lat &&
        this.cityInfo.lng
      ){
        return {
          token: this.userInfo.token,
          scene: 1101,
          ...this.cityInfo,
        }
      }
      else {
        return false
      }
    },
  },
  methods: {
    toMoreStation() {
      trackEvent('userteam_fx_home_more_ck', '“查看更多加油站”按钮')
      this.gotoLink(this.pageConfig.station.link)
    },
  },
})
</script>

<style lang="stylus" scoped>
  .warp
    min-height 100vh
    padding-bottom 180rpx
    font-size: 0;
    overflow hidden
    box-sizing: border-box;
    line-height: normal;
    .rule
      position absolute
      right 0
      border-radius: 100rpx 0 0 100rpx;
      font-family: PingFangSC-Semibold;
      font-size: 24rpx;
      letter-spacing: 1rpx;
      font-weight: bold
      padding 4rpx 16rpx 4rpx 25rpx
    .header-image
      width: 750rpx
    .container-station
      margin 52rpx 25rpx 0
      display: block
</style>

<script type="application/json">
{
  "component": true,
  "usingComponents": {
    "red-packet-close": "../../components/common/red-packet-close.mpx",
    "red-packet-open": "../../components/common/red-packet-open.mpx",
    "error-view": "../../components/common/error-view.mpx?async=error-view",
    "popup-result": "../../components/ny/popup-result.mpx",
    "gas-station-list": "@didi/ut-components/packages/gas-station-list/components/index.mpx",
    "image-list": "../../components/common/image-list.mpx",
    "res-banner": "../../components/common/res-banner.mpx"
  }
}
</script>
